module.exports = __webpack_public_path__ + "static/media/cracking-the-code-desktop.29dabc09.jpg";